import { EditorItemType } from '@/features/remotion-editor/editor/items/item-type';
import { DtoProjectType } from '@/shared/constants';

interface CaptionTimingPolicyInput {
  projectType: DtoProjectType | null | undefined;
  itemType: EditorItemType | null | undefined;
  assetType: string | null | undefined;
}

export const canEditCaptionTiming = ({
  projectType,
  itemType,
  assetType,
}: CaptionTimingPolicyInput): boolean =>
  projectType === DtoProjectType.agentVideoCaption &&
  itemType === 'captions' &&
  assetType === 'caption';
